import { Component, Input, OnChanges, AfterViewInit } from '@angular/core';

@Component({
    selector: 'ups-bar',
    template: require('./ups-bar.component.html')
})

export class UpsBarComponent implements OnChanges, AfterViewInit {

    @Input() size: string = 'lg';
    public classValue: boolean = false;
    public classButtonValue: boolean = false;
    public buttonArrow: boolean = false;
    public toggle: boolean = true;
    public expandedValue: boolean = false;

    constructor() { }

    ngAfterViewInit(): void {
        this.componentResize();
    }

    ngOnChanges() {
        this.componentResize();
    }

    private componentResize() {
        this.classValue = false;
        this.classButtonValue = false;
        if (this.size === 'xs' || this.size === 'sm') {
            this.classValue = true;
            this.classButtonValue = true;
        }
    }

    public expanded() {
        this.toggle = !this.toggle;
        if (this.toggle) {
            this.classButtonValue = false;
            this.buttonArrow = false;
            this.expandedValue = false;
        }
        else {
            this.classButtonValue = true;
            this.buttonArrow = true;
            this.expandedValue = true;
        }

    }

}